import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  es: {
    translation: {
      hero: {
        Title: 'Bella & Bestia',
        Date: '13 Septiembre 2025',
      },
      navbar: {
        home: 'Inicio',
        intro: 'Introducción',
        form: 'Formulario',
        details: 'Detalles del Día',
        contact: 'Contacto',
        openMenu: 'Menú',
        closeMenu: 'Cerrar',
      },
      guestForm: {
        title: 'Registrar Invitado',
        firstNamePlaceholder: 'Nombre del invitado',
        lastNamePlaceholder: 'Apellido del invitado',
        nameLastNameRequired: 'Por favor, nombre y apellido!',
        willAttend: 'Asistirá:',
        requiresBus: '¿Necesitas autobús?',
        allergies: 'Alergias',
        allergyList: {
          gluten: 'Gluten',
          crustaceans: 'Crustáceos',
          eggs: 'Huevos',
          fish: 'Pescado',
          peanuts: 'Cacahuetes',
          soybeans: 'Soja',
          milk: 'Leche',
          nuts: 'Frutos secos',
          celery: 'Apio',
          mustard: 'Mostaza',
          sesame: 'Sésamo',
          sulphites: 'Sulfitos',
          lupin: 'Altramuces',
          molluscs: 'Moluscos',
        },
        customAllergyPlaceholder: 'Otras alergias',
        menuOption: 'Opción de menú:',
        options: {
          normal: 'Normal',
          vegan: 'Vegano',
          child: 'Infantil',
        },
        submitButton: 'Confirmar asistencia',
        addAccompanying: 'Agregar acompañante',
        successMessage: '¡Invitado registrado con éxito!',
        errorMessage: 'Hubo un error al registrar al invitado.',
        processing: 'Procesando...',
        error409Message: 'Este invitado ya está registrado. Si deseas modificar los datos, contacta con los novios.',
        successTitle: '¡Invitado registrado con éxito!',
        errorTitle: '¡Error al registrar al invitado!',
        error400Message: 'Por favor, verifique los datos ingresados.',
        error500Message: 'Ha ocurrido un error en el servidor. Por favor, intente más tarde.',
        networkError: 'Error de conexión. Por favor, verifique su conexión a internet.',
        closeButton: 'Cerrar',

      },
      accompanyingGuest: {
        guestNumber: 'Acompañante {{index}}',
        firstName: 'Nombre',
        lastName: 'Apellido',
        remove: 'Eliminar acompañante',
        menuOption: 'Opción de menú:',
        busService: 'Requiere autobús:',
        allergies: 'Alergias',
        customAllergyPlaceholder: 'Otras alergias',
      },
      dayDetails:{
        title: 'Detalles del Día',
      },
      sections: {
        ceremony: {
          title: 'CEREMONIA',
          subtitle: 'Fantasyland Forest Theatre Tokyo',
          description: 'El Fantasyland Forest Theatre en Tokyo Disneyland es un lugar mágico donde los cuentos de hadas cobran vida. Rodeados de la magia de Disney y la belleza natural del bosque encantado, celebraremos nuestra ceremonia en este escenario de ensueño que refleja perfectamente nuestra historia de amor inspirada en Bella y Bestia.'
        },
        banquet: {
          title: 'BANQUETE',
          subtitle: 'Tokyo Disney Resort - Castillo de Bestia',
          description: 'El majestuoso Castillo de Bestia en Tokyo Disney Resort será el escenario perfecto para nuestra celebración. Un lugar donde la magia, la elegancia y la fantasía se combinan para crear la atmósfera ideal. Aquí podremos vivir nuestro propio cuento de hadas, rodeados de nuestros seres queridos en un ambiente verdaderamente encantador.'
        },
        timeline: {
          title: 'HORARIO',
          subtitle: '13:30 - 19:00',
          description: {
            ceremony:'Un momento lleno de amor y solemnidad, donde nuestros corazones se unirán ante familiares y amigos en este hermoso templo lleno de historia y encanto.',
            cocktail:'Brindaremos por el comienzo de esta gran celebración con aperitivos y bebidas, disfrutando de un ambiente relajado y alegre en los jardines de la finca.',
            dinner:'Degustaremos un menú especialmente seleccionado para compartir con nuestros seres queridos.',
            dance:'La celebración continúa con música, risas y mucha diversión. ¡Es hora de bailar, disfrutar y crear recuerdos inolvidables juntos!',
          },
          events: {
            ceremony: '13:30  Ceremonia',
            cocktail: '15:00  Cóctel',
            dinner: '17:00  Comida',
            dance: '19:00  Baile'
          }
        },
        map: {
          title: 'MAPA',
          viewRoute: 'Ver ruta en Google Maps'
        }
      },
      wedding_intro: {
        title: '¡Hola! Tenemos algo que contaros',
        text: '¡Por fin ha llegado el momento... Nos casamos! Después de compartir juntos tantos momentos especiales, hemos decidido dar este gran paso. La ceremonia será el 13 de septiembre en Fantasyland Forest Theatre Tokyo, y la celebración continuará en el mágico Castillo de Bestia en Tokyo Disney Resort.',
        help_text: 'Estamos organizando todo con muchísima ilusión, pero necesitamos vuestra colaboración. Al completar el formulario de asistencia, nos ayudaréis a confirmar vuestra presencia y a gestionar detalles importantes como el tipo de menú que preferís y si utilizaréis el autobús. ¡No os olvidéis de nada! Así, juntos podremos celebrar este día tan especial de la mejor manera posible.',
      },
      footer: {
        email: 'Correo electrónico',
        phone: 'Teléfono',
        copyright: 'Página de demostración hecha con cariño para vuestra boda.',
      },
    },
  },
  gl: {
    translation: {
      hero: {
        Title: 'Bella & Bestia',
        Date: '13 Setembro 2025',
      },
      navbar: {
        home: 'Inicio',
        intro: 'Introdución',
        form: 'Formulario',
        details: 'Detalles do Día',
        contact: 'Contacto',
        openMenu: 'Menú',
        closeMenu: 'Pechar',
      },
      guestForm: {
        title: 'Rexistrar Invitado',
        firstNamePlaceholder: 'Nome do invitado',
        lastNamePlaceholder: 'Apelido do invitado ',
        nameLastNameRequired: 'Por favor, nome e apelido!',
        willAttend: 'Asistirá:',
        requiresBus: 'Precisas autobús?',
        allergies: 'Alerxias',
        allergyList: {
          gluten: 'Gluten',
          crustaceans: 'Crustáceos',
          eggs: 'Ovos',
          fish: 'Peixe',
          peanuts: 'Cacahuetes',
          soybeans: 'Soia',
          milk: 'Leite',
          nuts: 'Froitos secos',
          celery: 'Apio',
          mustard: 'Mostaza',
          sesame: 'Sésamo',
          sulphites: 'Sulfitos',
          lupin: 'Altramuces',
          molluscs: 'Moluscos',
        },
        customAllergyPlaceholder: 'Outras alerxias',
        menuOption: 'Opción de menú:',
        options: {
          normal: 'Normal',
          vegan: 'Vexetal',
          child: 'Infantil',
        },
        submitButton: 'Confirmar asistencia',
        addAccompanying: 'Engadir acompañante',
        successMessage: '¡Invitado rexistrado con éxito!',
        errorMessage: 'Houbo un erro ao rexistrar o invitado.',
        alreadyRegistered: 'Este invitado xa está rexistrado. Se desexas modificar os datos, contacta cos noivos.',
        processing: 'Procesando...',
        error409Message: 'Este invitado xa está rexistrado. Se desexas modificar os datos, contacta cos noivos.',
        successTitle: '¡Invitado rexistrado con éxito!',
        errorTitle: '¡Error ao rexistrar o invitado!',
        error400Message: 'Por favor, verifique os datos ingresados.',
        error500Message: 'Houbo un erro inesperado. Inténtao de novo máis tarde.',
        networkError: 'Erro de conexión. Por favor, verifique a súa conexión a internet.',
        closeButton: 'Pechar',
        

      },
      accompanyingGuest: {
        guestNumber: 'Acompañante {{index}}',
        firstName: 'Nome',
        lastName: 'Apelido',
        remove: 'Eliminar acompañante',
        menuOption: 'Opción de menú:',
        busService: 'Necesitas autobús?',
        allergies: 'Alerxias',
        customAllergyPlaceholder: 'Outras alerxias',
      },
      dayDetails:{
        title: 'Detalles do Día',
      },
      sections: {
        ceremony: {
          title: 'CERIMONIA',
          subtitle: 'Fantasyland Forest Theatre Tokyo',
          description: 'O Fantasyland Forest Theatre en Tokyo Disneyland é un lugar máxico onde os contos de fadas cobran vida. Rodeados da maxia de Disney e a beleza natural do bosque encantado, celebraremos a nosa cerimonia neste escenario de soño que reflicte perfectamente a nosa historia de amor inspirada en Bella e Bestia.'
        },
        banquet: {
          title: 'BANQUETE',
          subtitle: 'Tokyo Disney Resort - Castelo de Bestia',
          description: 'O maxestuoso Castelo de Bestia en Tokyo Disney Resort será o escenario perfecto para a nosa celebración. Un lugar onde a maxia, a elegancia e a fantasía se combinan para crear a atmosfera ideal. Aquí poderemos vivir o noso propio conto de fadas, rodeados dos nosos seres queridos nun ambiente verdadeiramente encantador.'
        },
        timeline: {
          title: 'HORARIO',
          subtitle: '13:30 - 19:00',
          description: {
            ceremony:'Un momento cheo de amor e solemnidade, onde os nosos corazóns se unirán ante familiares e amigos nesta fermosa igrexa chea de historia e encanto.',
            cocktail:'Brindaremos polo comezo desta gran celebración con aperitivos e bebidas, gozando dun ambiente relaxado e alegre nos xardíns da finca.',
            dinner:'Degustaremos un menú especialmente seleccionado para compartilo cos nosos seres queridos.',
            dance:'A celebración continúa con música, risas e moita diversión. É hora de bailar, brincar e crear recordos inolvidables xuntos!',
          },
          events: {
            ceremony: '13:30  Cerimonia',
            cocktail: '15:00  Cóctel',
            dinner: '17:00  Comida',
            dance: '19:00  Baile'
          }
        },
        map: {
          title: 'MAPA',
          viewRoute: 'Ver ruta en Google Maps'
        },
      },
      wedding_intro: {
        title: 'Ola! Temos algo que contarvos',
        text: 'Por fin chegou o momento... Casamos! Si, despois de compartir tantos momentos xuntos, decidimos dar este gran paso. A cerimonia será o 13 de setembro en Fantasyland Forest Theatre Tokyo, e a celebración continuará no máxico Castelo de Bestia en Tokyo Disney Resort.',
        help_text: 'Estamos organizando todo con moitísima ilusión, pero precisamos da vosa axuda. Ao cubrir o formulario de asistencia, botarédesnos unha man confirmando se viredes e indicándonos detalles importantes, como o tipo de menú que preferides ou se vos apuntades ao autobús. ¡Non vos esquezades de nada! Así poderemos celebrar xuntos este día tan especial da mellor maneira posible.',
      },
      footer: {
        email: 'Correo electrónico',
        phone: 'Teléfono',
        copyright: 'Páxina de desmostración feita con agarimo para a vosa voda.',
      },
      error: {
        missingFields: "Por favor, completa todos os campos obrigatorios.",
        guestAlreadyExists: "Este invitado xa está rexistrado. Se desexas modificar os datos, contacta cos noivos.",
        serverError: "Houbo un erro inesperado. Inténtao de novo máis tarde."
    },
    
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'gl',
    fallbackLng: 'gl',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;